import { render, staticRenderFns } from "./GuppyChatFriendList.vue?vue&type=template&id=6a2580d6&"
import script from "./GuppyChatFriendList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatFriendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports